// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3Qnt-","title":"Images45_title__1zqyD","images":"Images45_images__3fb5X"};